
import * as Yup from 'yup'
import { TabOption } from '../../../../shared/components/FormTabHeader'
import { BaseEntity } from '../../../../shared/models/ApiModels';

export interface IPersonnelModel extends BaseEntity {
    tcIdentityNo: string;
    firstName: string;
    lastName: string;
    address: string;
    homePhone: string;
    workPhone: string;
    startDate: string;
    endDate: string;
    reference: string;
    notes: string;
    driverLicenseNo: string;
    driverLicenseClass: string;
    issueDate: string;
    issuePlace: string;
    gsm: string;
    email: string;
    birthDate: string;
    birthPlace: string;
    fatherName: string;
    motherName: string;
    identityNo: string;
    registrationCity: string;
    registrationDistrict: string;
    neighborhoodVillage: string;
    volumeNo: string;
    familyOrderNo: string;
    orderNo: string;
    bloodType: string;
    role: string;
    branch: string;
    isInactive: boolean;
    payDate: string;
    salary: string;
    multiply: string;
}

export const validationPersonnel = Yup.object({
    tcIdentityNo: Yup.string()
        .required('TC Kimlik No zorunlu')
        .matches(/^\d{11}$/, 'TC Kimlik No 11 rakamdan oluşmalıdır'),

    firstName: Yup.string().required('Ad zorunlu'),
    lastName: Yup.string().required('Soyad zorunlu'),
    address: Yup.string().required('Adres zorunlu'),

    startDate: Yup.string().required('Başlangıç tarihi zorunlu'),


    driverLicenseNo: Yup.string()
        .required('Ehliyet No zorunlu')
        .min(6, 'Ehliyet No en az 6 karakter')
        .max(12, 'Ehliyet No en fazla 12 karakter'),

    driverLicenseClass: Yup.string().required('Ehliyet sınıfı zorunlu'),
    issueDate: Yup.string().required('Veriliş tarihi zorunlu'),
    issuePlace: Yup.string().required('Verildiği yer zorunlu'),

    gsm: Yup.string()
        .required('GSM zorunlu')
        .matches(/^5\d{9}$/, 'GSM numarası 5 ile başlamalı ve 10 haneli olmalı'),

    email: Yup.string()
        .required('Email zorunlu')
        .email('Geçersiz email'),

    birthDate: Yup.string().required('Doğum tarihi zorunlu'),
    birthPlace: Yup.string().required('Doğum yeri zorunlu'),

    bloodType: Yup.string().required('Kan grubu zorunlu'),

    role: Yup.string().required('Görev alanı boş olamaz'),
    branch: Yup.string().required('Şube zorunlu'),
})

export const initialPersonnel: IPersonnelModel = {
    id: '',
    tcIdentityNo: '',
    firstName: '',
    lastName: '',
    address: '',
    homePhone: '',
    workPhone: '',
    startDate: '',
    endDate: '',
    reference: '',
    notes: '',
    driverLicenseNo: '',
    driverLicenseClass: '',
    issueDate: '',
    issuePlace: '',
    gsm: '',
    email: '',
    birthDate: '',
    birthPlace: '',
    fatherName: '',
    motherName: '',
    identityNo: '',
    registrationCity: '',
    registrationDistrict: '',
    neighborhoodVillage: '',
    volumeNo: '',
    familyOrderNo: '',
    orderNo: '',
    bloodType: '',
    role: '',
    branch: '',
    isInactive: false,
    payDate: '',
    salary: '',
    multiply: '',
};

export const tabOptions: TabOption<'form' | 'list'>[] = [
    { key: 'form', title: 'Yeni Personel ', icon: 'bi bi-geo-alt' },
    { key: 'list', title: 'Personel Listesi', icon: 'bi bi-list' },

]

export const IN_OR_OUT = [
    { value: 'ic', label: 'İç Ekip' },
    { value: 'dis', label: 'Dış Ekip' }
]